import { PureLightTheme } from "../../../styles/theme"

export const CardImg = {
    width: '120px',
    height: '120px',
    borderRadius: '50%',
    objectFit: 'cover',
    marginRight: 3,

    [PureLightTheme.breakpoints.down('sm')]: {
        display: 'none',
    }
}

export const CardImgMobile = {
    maxWidth: '600px',
    width: 'calc(100% + 24px)',
    maxHeight: '600px',
    objectFit: 'cover',
    mb: 1.5,
    mx: -1.5,
    '@media (min-width:600px)': {
        display: 'none',
    },
}

export const TypTitle = {
    marginTop: 1.5,
    marginBottom: 1,
    [PureLightTheme.breakpoints.down('sm')]: {
        fontSize: '18px',
        marginTop: 0,
        marginBottom: 0,
    }
}

export const TypCategories = {
    marginBottom: 1,

    [PureLightTheme.breakpoints.down("sm")]: {
        marginBottom: 0.5,
    }
}
